import React, {Component} from 'react';
import './Leavebalance.css';
import axios from 'axios';
class  Leavebalance extends React.Component {
    constructor(props){
        super(props);
        this.state = {
           
            leave:[],
            
          };
    }

    fetchData( year_start , year_end ){
        //alert(year_start)
        //alert(year_end )
        const USR_TOKEN = localStorage.getItem("userToken")
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/method/frappe.desk.query_report.run?report_name=Employee Leave Balance&filters={"company":"Marunadan Malayali","from_date":"'+year_start+'","to_date":"'+year_end+'"}'), {
            headers : {'Authorization' : USR_TOKEN, 
        'content-type': 'application/json'}
        })
        .then(response=>{
                this.setState({leave:response.data['message']['result']})
                //this.setState({earn:response.data.data.earnings})
                //console.log(response.data.data['message']['result'])

        })
        .catch(err=>{
            //window.location.href = "/";
            //this.setState({name:response.data['data'][0]})
            //console.log("done")
        })
    }

    async componentDidMount(){
        /* const currentYear = new Date().getFullYear();
console.log(currentYear); 

const firstDay = new Date(currentYear, 0, 1);
console.log(firstDay); 

const lastDay = new Date(currentYear, 11, 31);
console.log(lastDay);  */
                const USR_TOKEN = localStorage.getItem("userToken")
                axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Fiscal Year?fields=["disabled","name","year_start_date","year_end_date"]&filters=[["disabled","=","0"]]'), {
                    headers : {'Authorization' : USR_TOKEN, 
                'content-type': 'application/json'}
                })
                .then(response=>{
                    this.fetchData(response.data.data[0].year_start_date,response.data.data[0].year_end_date)
                        //this.setState({leave:response.data['message']['result']})
                        //this.setState({earn:response.data.data.earnings})
                        //console.log(response.data.data['message']['result'])
                 //alert("ok")
                })
                .catch(err=>{
                    //window.location.href = "/";
                    //this.setState({name:response.data['data'][0]})
                    //console.log("done")
                })




        

    }

  render() {
      
        return <div className="">
            <h5 className="mb-3">Employee Leave Balance</h5>
        <table className="table align-middle mb-0 bg-white leave-tab-layout">
            <thead className="bg-light">
                <tr>
                <th>Leave Type</th>
                <th className="text-center">Opening Balance</th>
                <th className="text-center">New Leave(s) Allocated</th>
                <th className="text-center">Leave(s) Taken</th>
                <th className="text-center">Closing Balance</th>
                </tr>
            </thead>
            <tbody>
            { this.state.leave.map((item,k)=>{
                if(item.leave_type == 'Meternity Leave - 3 Months' )
                 return ""
                else if(item.leave_type == 'Meternity Leave - 6 Months')
                return ""
                else
                 return(
                        <tr key={k} >
                            <td>
                                <div className="d-flex align-items-center">
                                    <div className="ms-3">
                                        <p className="fw-bold mb-1">{item.leave_type}</p>
                                    </div>
                                </div>
                            </td>
                            <td className="text-center">
                                <p className="fw-normal mb-1">{item.opening_balance}</p>
                            </td>
                            <td className="text-center">
                                <p className="fw-normal mb-1">{item.leaves_allocated}</p>
                            </td>
                            <td className="text-center">{item.leaves_taken}</td>
                            <td className="text-center">
                            <p className="fw-normal mb-1">{(item.opening_balance + item.leaves_allocated) - item.leaves_taken}</p>
                            </td>
                        </tr>                       
                ) })}
                
            </tbody>
</table>
</div>

}
}
export default Leavebalance;